import React, { useState, useEffect, useRef } from 'react';
import "./header.css"; // Import the CSS styles
import star from '../../Assets/starcontact.png';

const Header = () => {
  // State to control menu visibility
  const [menuOpen, setMenuOpen] = useState(false);
  const dropdownRef = useRef(null); // Reference for the dropdown menu

  // Toggle the menu
  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  // Close dropdown when clicking outside of it
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setMenuOpen(false); // Close the menu if clicked outside
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <header className="header">
      {/* Logo */}
      <a href="/">
        <img src={require('../../Assets/logocolor.png')} alt="Logo" />
      </a>

      {/* Right Section */}
      <div className="header-right">
        <div className="header-btn1">
          <img src={star} alt="Star Bullet" className="star-image" />
          <span>Bookings open</span>  
          <button className="header-btn" onClick={() => window.open('https://wa.me/971567257579', '_blank')}>
            Contact
          </button>
        </div>

        {/* Menu Icon */}
        <div className="menu-icon" onClick={toggleMenu}>
          <div></div>
          <div></div>
          <div></div>
        </div>

        {/* Dropdown Menu */}
        {menuOpen && (
          <div className="dropdown-menu" ref={dropdownRef}>
            <a className="menu-item" href="/">
              Home
            </a>
            <a className="menu-item" href="/allservices">
              Services
            </a>
            <a className="menu-item" href="/#blog">
              Blog
            </a>
            <a className="menu-item" href="/#gallery">
              Gallery
            </a>
            <a className="menu-item" href="/#contact">
              Contact
            </a>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
